import { render, staticRenderFns } from "./invHold.vue?vue&type=template&id=7b611a0a&"
import script from "./invHold.vue?vue&type=script&lang=js&"
export * from "./invHold.vue?vue&type=script&lang=js&"
import style0 from "./invHold.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports